import CustomAmount from './CustomAmount';

export default CustomAmount;
